import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Search as SearchIcon } from "lucide-react";
import { useSEO } from "@/lib/seo";
import { api } from "@/lib/api";

export default function Search() {
    const [params, setParams] = useSearchParams();
    const q = params.get("q") || "";
    const [term, setTerm] = useState(q);
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    useSEO({ title: q ? `Search: ${q} — RKS Systems` : "Search — RKS Systems" });

    useEffect(() => {
        if (!q || q.length < 2) { setResults([]); return; }
        setLoading(true);
        api.get("/search", { params: { q } }).then(({ data }) => setResults(data.results || [])).finally(() => setLoading(false));
    }, [q]);

    const submit = (e) => {
        e.preventDefault();
        setParams(term ? { q: term } : {});
    };

    return (
        <div data-testid="page-search" className="container-app py-16 lg:py-24">
            <h1 className="font-heading text-4xl font-extrabold tracking-tight">Search</h1>
            <form onSubmit={submit} className="mt-6 flex items-center gap-3 rounded-md border border-border bg-white px-4 py-3 max-w-2xl">
                <SearchIcon className="h-4 w-4 text-muted-foreground" strokeWidth={1.75} />
                <input data-testid="search-input" autoFocus value={term} onChange={(e) => setTerm(e.target.value)} placeholder="Search services, industries, products, blogs..." className="flex-1 bg-transparent outline-none" />
                <button data-testid="search-submit" type="submit" className="text-sm font-semibold text-primary">Search</button>
            </form>
            <div className="mt-10">
                {loading && <div className="text-muted-foreground">Searching...</div>}
                {!loading && q && results.length === 0 && <div className="text-muted-foreground" data-testid="search-no-results">No results for &quot;{q}&quot;.</div>}
                <div className="grid gap-3">
                    {results.map((r) => (
                        <Link key={`${r.type}-${r.id}`} to={r.url} data-testid={`search-result-${r.id}`} className="rounded-lg border border-border bg-card px-5 py-4 hover:border-primary/40 hover:shadow-sm transition-all">
                            <div className="text-xs font-semibold uppercase tracking-widest text-primary">{r.type.replace("_", " ")}</div>
                            <div className="mt-1 font-heading font-semibold">{r.title}</div>
                            <div className="mt-1 text-sm text-muted-foreground line-clamp-2">{r.excerpt}</div>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
}
